const specs = {
  standard: {
    operation: 'create',
    create: {
      type: 'bool',
      product: 'vrHeadset_standard',
    },
  },
};


const dependencies = {
  hard: [],
  soft: [],
};


export default { specs, dependencies };
